export default {
  addNewTab({ commit }, tab) {
    return commit('addNewTab', tab);
  },
  removeTab({ commit }, index) {
    return commit('removeTab', index);
  },
  updateTabTitle({ commit }, payload) {
    return commit('updateTabTitle', payload);
  },
  removeAllTabs({ commit }) {
    return commit('removeAllTabs');
  },
  closeNonActiveTabs({ commit }, data) {
    return commit('removeInactiveTabs', data);
  },
};
